import { Row } from 'antd'
import LineItemImage from 'app/components/Core/LineItem/Image'
import Form from 'app/components/Core/SubItem/Form'
import KInputText from 'app/components/Modules/Form/KInputText'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useLazyQuery } from 'app/lib/hooks/useQuery'
import { queries } from 'app/queries'
import { useEffect } from 'react'
interface Props {
  attachmentId: number
  parentItem: ILineItem
  portalId: string
  onSuccess: () => void
}

const SubItemCreate: React.FC<Props> = ({ attachmentId, parentItem, portalId, onSuccess }) => {
  const {
    execute,
    loading,
    data: { attachment }
  } = useLazyQuery<{ attachment: IAttachment }>(queries.attachment.get)

  useEffect(() => {
    execute({ variables: { id: attachmentId } })
  }, [])

  return (
    <Row>
      <KCol span={24} loading={loading}>
        <If condition={attachment}>
          <Row gutter={[0, 12]} align="middle">
            <KCol span={5}>
              <LineItemImage member={attachment.categorySegment} />
            </KCol>
            <KCol span={19}>
              <h5 className="text-truncate text-black mb-0">{attachment.name}</h5>
            </KCol>
            <KCol span={24}>
              <Form
                props={{ onSuccess, portalId, action: 'create' }}
                member={{
                  lineItemId: String(parentItem.id),
                  attachmentId: attachmentId,
                  startDate: parentItem?.startDate,
                  returnDate: parentItem?.returnDate,
                  earliestAvailableDateTime: attachment.categorySegment?.earliestAvailableDateTime
                }}>
                <KInputText name="lineItemId" hidden />
                <KInputText name="attachmentId" hidden />
              </Form>
            </KCol>
          </Row>
        </If>
      </KCol>
    </Row>
  )
}

export default SubItemCreate
